import axios from 'axios'

export async function fetchLotIdsInDateRange (startDate, endDate) {
  const params = {
    page_size: 0,
    fields: 'id',
    created_at__gte: startDate,
    created_at__lte: endDate
  }
  let ids = []
  const response = await axios.get(`/api/lots/`, { params })
  if (response.data) ids = response.data.map(lot => lot.id)
  return ids
}

// Updates the current lot to reflect that the purchase lots are complete
export async function patchLotAllocationsComplete (lotId, value) {
  const response = await axios.patch(`/api/lots/${lotId}/`, { purchase_allocations_complete: value })
  return response.data.purchase_allocations_complete
}

export async function fetchLotTransitAllocations (lotId) {
  return axios.get(`/api/lots/${lotId}/transit_allocations/`)
}

export async function fetchLotIntakes (lotId) {
  return axios.get(`/api/lots/${lotId}/intakes/`)
}

export async function fetchLot (lotId) {
  return axios.get(`/api/lots/${lotId}/`)
}

export async function fetchLotAdvances (lotId) {
  return axios.get(`/api/lots/${lotId}/advances/`)
}

export async function fetchLotAllocations (lotId) {
  return axios.get(`/api/lots/${lotId}/?fields=allocations`)
}
